import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function DraggableRow(props) {
  const { height, width, iconColor } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 44 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line y1="18" x2="42" y2="18" stroke={iconColor} strokeWidth="3" />
      <line y1="44" x2="42" y2="44" stroke={iconColor} strokeWidth="3" />
      <line y1="31" x2="42" y2="31" stroke={iconColor} strokeWidth="3" />
      <path d="M21 0L27.9282 10.5H14.0718L21 0Z" fill={iconColor} />
      <path d="M21 64L14.0718 53.5H27.9282L21 64Z" fill={iconColor} />
    </svg>
  );
}

DraggableRow.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

DraggableRow.defaultProps = {
  height: undefined,
  width: 20,
  iconColor: colors.colorGrey
};

export default DraggableRow;
